export default __webpack_public_path__ + "static/media/product_8.90494c70.png";